import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Typography, Grid, ThemeProvider, Card, CardContent } from '@mui/material';
import config from 'src/config';
import { useNavigate } from 'react-router-dom';
import { getToken, login, storeKey, storeToken } from 'src/services/auth.service';
import { createTheme } from '@mui/material/styles'
import { AuthHeader } from 'src/components/auth/header';
import { AuthFooter } from 'src/components/auth/footer';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BusinessIcon from '@mui/icons-material/Business';

const theme = createTheme({
    palette: {
      primary: {
        main: '#ff9933'
      }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                    textTransform: 'none'
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderRadius: '8px',
                        },
                    },
                },
            },
        },
    }
});

class RegisterTypePage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            show_password: false,

            pristine: {
                username: true,
                password: true,
                confirm_password: true
            },

            // payload
            username: '',
            password: ''
        }

    }

    async componentDidMount() {
        let token = await getToken();
        if (token) {
            this.props.navigate('/files');
        }
    }


    validateUsername(username, checkPristine = true) {

        if (checkPristine && this.state.pristine.username) {
            return true;
        }

        if (!username) {
            return false;
        }

        if (username.indexOf('@') === -1) {
            return false;
        }

        if (username.indexOf('.') === -1) {
            return false;
        }

        return true;
    }

    validatePassword(password, checkPristine = true) {

        if (checkPristine && this.state.pristine.password) {
            return true;
        }

        if (!password) {
            return false;
        }

        if (password.length < 8) {
            return false;
        }

        return true;
    }

    validateForm() {
        return this.validateUsername(this.state.username, false) && this.validatePassword(this.state.password, false);
    }


    async handleLogin() {
        let payload = {
            username: this.state.username,
            password: this.state.password
        };

        let loginRes = await login(payload);
        if (loginRes.error) {
            console.log(loginRes.error);
            alert('Error: ' + loginRes.error);
        }

        if (loginRes.token) {
            await storeToken(loginRes.token);
            await storeKey('username', loginRes?.data?.username);
            if (loginRes?.data?.role) {
                await storeKey('role', loginRes?.data?.role);
            } else {
                await storeKey('role', 'user');
            }

            // Redirect to verification page
            this.props.navigate('/verify');

            // this.props.navigate('/files');
        }
    }

    render() {

        return (
            <ThemeProvider theme={theme}>
                <Helmet>
                    <title> Login | {config.APP_NAME} </title>
                </Helmet>


                <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }}>

                    <Grid item xs={12}>
                        <AuthHeader />
                    </Grid>

                    <Grid container style={{ justifyContent: 'center', alignItems: 'center' }} spacing={2}>

                        <Grid item xs={12} sx={{ textAlign: 'center', mb: 3 }}>
                            <Typography variant="h6" sx={{ textAlign: 'center' }} fontWeight={'bold'}>
                                Let's get started
                            </Typography>
                        </Grid>


                        <Grid item xs={12} sm={12} md={12} lg={2} xl={3}></Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                            <Card
                                style={{ cursor: 'pointer', border: '2px solid #eee', borderRadius: '15px', backgroundColor: 'transparent', height: '100%' }}
                                onClick={() => { this.props.navigate('/individualregister') }}
                            >
                                <CardContent sx={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 180 }}>
                                    <PersonOutlineIcon />
                                    <Typography variant="h6" fontWeight={'bold'} sx={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                                        I'm an Individual
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 2, textAlign: 'center', color: 'gray' }}>
                                        Label, search and organize files across all your drives in one place
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                            <Card
                                style={{ cursor: 'pointer', border: '2px solid #eee', borderRadius: '15px', backgroundColor: 'transparent', height: '100%' }}
                                onClick={() => { this.props.navigate('/businessregister') }}
                            >
                                <CardContent sx={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 180 }}>
                                    <BusinessIcon />
                                    <Typography variant="h6" fontWeight={'bold'}>
                                        I'm a Business User
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 2, textAlign: 'center', color: 'gray' }}>
                                        Create teams, organize departments, assign roles and bring clarity to shared files and collaboration.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={2} xl={3}></Grid>

                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={8} lg={6} xl={4} sx={{ mx: 'auto' }}>
                            <AuthFooter />
                        </Grid>
                    </Grid>
                </Grid>
            </ThemeProvider>
        )
    }
}

export default function (props) {
    const navigate = useNavigate();

    return <RegisterTypePage {...props} navigate={navigate} />;
}

